import router from "@/router"
import RouteNames from "@/util/route_names"
import ProdukteLogic from "@/logic/produkte_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import { ConverterUtil } from "mangutil"
import {
  PreislisteZeitraumRequest,
  Terminart,
  RemoteResult,
  PlisteProduktZeit,
  BstlArtikel,
  Bestellung,
  BPArtikelHinzufuegenRequest,
  BPArtikelAnzahlRequest,
  IdRequest,
  NachbestellungPending,
  Nachbestellung,
  LoadState,
} from "mangdto"

export default class NachbestellungLogic extends ProdukteLogic {
  bestellung: Bestellung = null
  bestellungCompleted: boolean = false
  insertBestellungLoadState: LoadState = LoadState.Idle

  private _warenkorb: BstlArtikel[] = []

  get warenkorb(): BstlArtikel[] {
    return this._warenkorb
  }

  get warenkorbGefuellt(): boolean {
    return this._warenkorb.length > 0
  }

  bestellungEinfuegen(): void {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.NACHBESTELLEN.BESTAETIGEN,
    })
  }

  loadPreislisten() {
    this.listeLoadState = LoadState.Loading

    var request = new PreislisteZeitraumRequest()
    var terminart = this.bestellung.terminart

    if (terminart == Terminart.Reservierung) {
      request.zeitpunkt = this.bestellung.reservierung.zeitVon
    } else if (terminart == Terminart.Sofortbestellung) {
      request.zeitpunkt = this.bestellung.bestellZp
    }

    request.filialeId = this.filiale.filialeId

    if (this.mainLogic.bestellung.nachbestellungPending)
      this._warenkorb =
        this.mainLogic.bestellung.nachbestellungPending.artikelliste

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.listeLoadState = LoadState.Completed
          this.preisliste = response.data.payload
        } else {
          this.listeLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.listeLoadState = LoadState.Error
      })
  }

  init() {
    this.bestellung = this.mainLogic.bestellung
    if (this.bestellung != null) this.loadPreislisten()

    this.mainLogic.bestellungListeners.push(() => {
      this.bestellung = this.mainLogic.bestellung
      if (this.bestellung != null) this.loadPreislisten()
    })
  }

  increment(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.bestellung.nachbestellungPending.id
    request.artikelId = artikel.id
    request.anzahl = artikel.anzahl + 1

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendernNachbestellung,
      request,
    ).then((response) => {
      if (response.data.success) {
        artikel.anzahl += 1
      }
    })
  }

  decrement(artikel: BstlArtikel) {
    if (artikel.anzahl > 1) {
      var request = new BPArtikelAnzahlRequest()
      request.id = this.mainLogic.bestellung.nachbestellungPending.id
      request.artikelId = artikel.id
      request.anzahl = artikel.anzahl - 1

      Poster.postUser<RemoteResult<any>>(
        RestPaths.bestellungpendingArtikelAendernNachbestellung,
        request,
      ).then((response) => {
        if (response.data.success) {
          artikel.anzahl -= 1
        }
      })
    }
  }

  remove(artikel: BstlArtikel) {
    var request = new BPArtikelAnzahlRequest()
    request.id = this.mainLogic.bestellung.nachbestellungPending.id
    request.artikelId = artikel.id
    request.loeschen = true

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingArtikelAendernNachbestellung,
      request,
    ).then((response) => {
      if (response.data.success) {
        this.warenkorb.splice(
          this.warenkorb.findIndex((x) => {
            return x.id === artikel.id
          }),
          1,
        )
        if (this.warenkorb.length == 0) {
          router.go(-1)
        }
      }
    })
  }

  addArtikel(artikel: BstlArtikel) {
    this.insertArtikelLoadState = LoadState.Loading

    var request = new BPArtikelHinzufuegenRequest()
    request.artikelData = ConverterUtil.convertBstlArtikel(artikel)
    request.id = this.mainLogic.bestellung.nachbestellungPending.id

    Poster.postMember<RemoteResult<BstlArtikel>>(
      RestPaths.bestellungpendingArtikelHinzufuegenNachbestellung,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.insertArtikelLoadState = LoadState.Completed

          this.warenkorb.push(response.data.payload)
          this.artikel = null
          this.artikelDialogVisible = false
          //router.go(-1)
        } else {
          this.insertArtikelLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.insertArtikelLoadState = LoadState.Error
      })
  }

  bestellungAufgeben() {
    this.insertBestellungLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = this.mainLogic.bestellung.nachbestellungPending.id

    Poster.postUser<RemoteResult<Nachbestellung>>(
      RestPaths.bestellungpendingNachbestellungAufgeben,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.insertBestellungLoadState = LoadState.Completed
          this.bestellungCompleted = true
          this.mainLogic.bestellung.sofort.nachbestellungen.push(
            response.data.payload,
          )
          this.mainLogic.bestellung.nachbestellungPending =
            new NachbestellungPending()
        } else {
          this.insertBestellungLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.insertBestellungLoadState = LoadState.Error
      })
  }

  backToOverview() {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { id: this.bestellung.id },
    })
  }
}
